import axios from 'axios';
import { BACKEND_URL, API_URL } from '../config';

export const getBackendUrl = () => BACKEND_URL;

const api = axios.create({
  baseURL: API_URL,
});

// Add auth token and cache-busting headers to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Prevent caching of API responses
  config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
  config.headers['Pragma'] = 'no-cache';
  return config;
});

// Global response interceptor - handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - clear and redirect to login
      const currentPath = window.location.pathname;
      if (currentPath !== '/auth' && currentPath !== '/' && currentPath !== '/login') {
        localStorage.removeItem('token');
        window.location.href = '/auth';
      }
    }
    return Promise.reject(error);
  }
);

// Auth
export const register = (data) => api.post('/auth/register', data);
export const login = (data) => api.post('/auth/login', data);
export const getMe = () => api.get('/auth/me');

// Conversations
export const createConversation = (data) => api.post('/conversations', data);
export const getConversations = () => api.get('/conversations');
export const getMessages = (conversationId) => api.get(`/conversations/${conversationId}/messages`);
export const deleteConversation = (conversationId) => api.delete(`/conversations/${conversationId}`);
export const sendMessage = (data) => api.post('/chat', data);

// Knowledge Base
export const uploadDocument = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/knowledge/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const getDocuments = () => api.get('/knowledge/documents');
export const createKnowledgeEntry = (data) => api.post('/knowledge/entries', data);
export const getKnowledgeEntries = () => api.get('/knowledge/entries');

// Saved Answers
export const createSavedAnswer = (data) => api.post('/saved-answers', data);
export const getSavedAnswers = () => api.get('/saved-answers');
export const deleteSavedAnswer = (id) => api.delete(`/saved-answers/${id}`);

export default api;
